import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "like-finger",
    iconColor: "white",
    text: "Customer and agent \nsatisfaction",
    listItemCustomStyle: { width: "252px" },
  },
  {
    icon: "window-and-comment",
    iconColor: "white",
    text: "Proactive \ncommunication",
    listItemCustomStyle: { width: "252px" },
  },
  {
    icon: "personWithArrows",
    iconColor: "white",
    text: "Enhanced decision \nmaking",
    listItemCustomStyle: { width: "252px" },
  },
];

const DATA_BENEFITS_IEAM_1 = {
  title: "Proactive notifications",
  titleNumber: "2.",
  text: "ILO uses analytics and Gen AI to enhance personalized notification management for \ncustomers and business groups to deliver best-in-class customer service experience.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ILO_104"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_102"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_Introduction_03.png",
};

export default DATA_BENEFITS_IEAM_1;
